module.exports = __webpack_public_path__ + "img/house-3@2x.a4cfcc9d.jpg";